import { useCallback, useEffect, useState } from 'react';

import { monitorApi } from '../api/monitor';
import type { DashboardState } from '../api/monitor';

/** Mesma cadência do `useApiEndpoints`: a tela inteira envelhece junto. */
const REFRESH_MS = 60_000;

export interface DashboardController {
  state: DashboardState | null;
  loading: boolean;
  error: string | null;
  reload: () => Promise<void>;
}

export function useDashboard(): DashboardController {
  const [state, setState] = useState<DashboardState | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const reload = useCallback(async () => {
    try {
      setState(await monitorApi.dashboard());
      setError(null);
    } catch (cause) {
      setError((cause as Error).message);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    void reload();
  }, [reload]);

  // Com a aba escondida não adianta gastar request.
  useEffect(() => {
    const timer = window.setInterval(() => {
      if (document.visibilityState === 'visible') void reload();
    }, REFRESH_MS);

    return () => window.clearInterval(timer);
  }, [reload]);

  return { state, loading, error, reload };
}
